import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import ReactMarkdown from 'markdown-to-jsx';
import * as React from 'react';

const options = {
  overrides: {
    // h1: { component: Typography, props: { gutterBottom: true, variant: 'h5' } },
    // h2: { component: Typography, props: { gutterBottom: true, variant: 'h6' } },
    // h3: { component: Typography, props: { gutterBottom: true, variant: 'subtitle1' } },
    h4: {
      component: Typography,
      props: { gutterBottom: true, variant: 'caption', paragraph: true },
    },
    p: { component: Typography, props: { paragraph: true } },
    a: { component: Link },
  },
};

const Markdown: React.FC<{ attributes: {}; body: string }> = ({
  attributes,
  body,
}: {
  attributes: {};
  body: string;
}) => {
  return (
    <Box px={{ xs: 0, md: 5, lg: 10 }} pt={1}>
      <ReactMarkdown options={options}>{body}</ReactMarkdown>
    </Box>
  );
};

export default Markdown;
